import classNames from 'classnames';
import { useColors, ColorLoader } from '../hooks/useColors';

type Props = {
    value: number;
    onChangeValue: (value: number) => void;
    min: number;
    max: number;
    step?: number;
    markerStep?: number;
    className?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
};
export function Slider({
    value,
    onChangeValue,
    min,
    max,
    step = 1,
    markerStep = step,
    className,
    style,
    disabled = false,
}: Props) {
    const colors = useColors();
    return (
        <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(e) => onChangeValue(Number(e.target.value))}
            disabled={disabled}
            className={classNames(className, 'slider-custom w-full')}
            style={{
                ...style,
                backgroundImage: `${getStepMarkers(min, max, markerStep, colors)}, ${getTrackBackground(value, min, max, disabled, colors)}`,
                backgroundSize: 'auto 8px, auto',
                backgroundRepeat: 'no-repeat',
                backgroundPositionY: 'center',
                borderRadius: '30px',
            }}
        />
    );
}

function getTrackBackground(
    current: number,
    min: number,
    max: number,
    disabled: boolean = false,
    colors: ColorLoader,
): string {
    const percent = ((current - min) / (max - min)) * 100;
    const filledColor = disabled
        ? colors('cool-grey')
        : colors('background-default-tertiary');
    return `linear-gradient(to right, ${filledColor} 0%, ${filledColor} ${percent}%, white ${percent}%, white 100%)`;
}

function getStepMarkers(
    min: number,
    max: number,
    step: number,
    colors: ColorLoader,
): string {
    const padding = 15;
    const markerWidth = 1;
    const markerColor = colors('dark-red');
    const stops = [];
    for (let i = min; i <= max; i += step) {
        const percent = ((i - min) / (max - min)) * 100;
        const inset = percent * 2 - 100;
        const offset = (inset / 100) * padding;
        const pos = `calc(${percent}% - ${offset}px)`;
        stops.push(
            `transparent ${pos}, ${markerColor} ${pos}, ${markerColor} calc(${pos} + ${markerWidth}px), transparent calc(${pos} + ${markerWidth}px)`,
        );
    }
    return `linear-gradient(to right, ${stops.join(', ')})`;
}
